import { notifications } from "@mantine/notifications";

export function showErrorNotification(message: string) {
  notifications.show({
    title: "Erro!",
    message,
    color: "red",
    autoClose: 5000,
  });
}
